var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuminaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21C5.71667 21 5.47917 20.9042 5.2875 20.7125C5.09583 20.5208 5 20.2833 5 20C5 19.7167 5.09583 19.4792 5.2875 19.2875C5.47917 19.0958 5.71667 19 6 19H18C18.2833 19 18.5208 19.0958 18.7125 19.2875C18.9042 19.4792 19 19.7167 19 20C19 20.2833 18.9042 20.5208 18.7125 20.7125C18.5208 20.9042 18.2833 21 18 21H6ZM6.7 17.5C6.21667 17.5 5.7875 17.3417 5.4125 17.025C5.0375 16.7083 4.80833 16.3083 4.725 15.825L3.725 9.475C3.69167 9.475 3.65417 9.47917 3.6125 9.4875C3.57083 9.49583 3.53333 9.5 3.5 9.5C3.08333 9.5 2.72917 9.35417 2.4375 9.0625C2.14583 8.77083 2 8.41667 2 8C2 7.58333 2.14583 7.22917 2.4375 6.9375C2.72917 6.64583 3.08333 6.5 3.5 6.5C3.91667 6.5 4.27083 6.64583 4.5625 6.9375C4.85417 7.22917 5 7.58333 5 8C5 8.11667 4.9875 8.225 4.9625 8.325C4.9375 8.425 4.90833 8.51667 4.875 8.6L8 10L11.125 5.725C10.9417 5.59167 10.7917 5.41667 10.675 5.2C10.5583 4.98333 10.5 4.75 10.5 4.5C10.5 4.08333 10.6458 3.72917 10.9375 3.4375C11.2292 3.14583 11.5833 3 12 3C12.4167 3 12.7708 3.14583 13.0625 3.4375C13.3542 3.72917 13.5 4.08333 13.5 4.5C13.5 4.75 13.4417 4.98333 13.325 5.2C13.2083 5.41667 13.0583 5.59167 12.875 5.725L16 10L19.125 8.6C19.0917 8.51667 19.0625 8.425 19.0375 8.325C19.0125 8.225 19 8.11667 19 8C19 7.58333 19.1458 7.22917 19.4375 6.9375C19.7292 6.64583 20.0833 6.5 20.5 6.5C20.9167 6.5 21.2708 6.64583 21.5625 6.9375C21.8542 7.22917 22 7.58333 22 8C22 8.41667 21.8542 8.77083 21.5625 9.0625C21.2708 9.35417 20.9167 9.5 20.5 9.5C20.4667 9.5 20.4292 9.49583 20.3875 9.4875C20.3458 9.47917 20.3083 9.475 20.275 9.475L19.275 15.825C19.1917 16.3083 18.9625 16.7083 18.5875 17.025C18.2125 17.3417 17.7833 17.5 17.3 17.5H6.7ZM6.7 15.5H17.3L17.95 11.325L16.8 11.825C16.3667 12.0083 15.925 12.0417 15.475 11.925C15.025 11.8083 14.6583 11.5583 14.375 11.175L12 7.9L9.625 11.175C9.34167 11.5583 8.975 11.8083 8.525 11.925C8.075 12.0417 7.63333 12.0083 7.2 11.825L6.05 11.325L6.7 15.5Z",
    fill: "url(#paint0_linear_11757_124040)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11757_124040",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#FF7D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDA704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#FFC15C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuminaryIcon);
export default __webpack_public_path__ + "static/media/luminary-icon.bc47fafe2e12e9520bf6f3a818b90014.svg";
export { ForwardRef as ReactComponent };